import FileDownload from 'js-file-download';
import { axiosKK } from './networkRequest';

export function downloadCsv(
  url: string,
  filename: string,
  params?: Record<string, unknown>
): Promise<void> {
  const queryParams = { ...(params || {}), format: 'csv' };
  return axiosKK
    .get(url, { params: queryParams, responseType: 'blob' })
    .then((response) => {
      FileDownload(response.data, filename);
    });
}

export function downloadPdf(
  url: string,
  filename: string,
  params?: Record<string, unknown>
): Promise<void> {
  return axiosKK
    .get(url, { params, responseType: 'blob' })
    .then((response) => {
      FileDownload(response.data, filename);
    });
}
